import { useState } from "react";
import EventDetailPage from "../Components/EventDetail";
import EventStatusBanner from "../Components/EventStatusBanner";
import TicketList from "../Components/TicketList";

const EventDetails = () => {
  const [status, setStatus] = useState(null);

  const isEventActive = status === 'on';

  return (
    <div className="min-h-screen mb-32">
      <EventDetailPage setStatus={setStatus} />

      {!isEventActive && (
        <EventStatusBanner status={status} />
      )}

      {isEventActive && (
        <TicketList />
      )}
    </div>
  );
};


export default EventDetails;
